export default "__VITE_ASSET__DEMZaITJ__"